// extracted by mini-css-extract-plugin
export default {"main":"style_main__HNK+c","all":"style_all__RZHRp"};